// extracted by css-extract-rspack-plugin
export default {"container":"container-PlId17"};// extracted by css-extract-rspack-plugin
export default {"container":"container-PlId17"};